"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypeTableNames = void 0;
var ProductTypeTableNames;
(function (ProductTypeTableNames) {
    ProductTypeTableNames["Author"] = "author";
    ProductTypeTableNames["Newsletter"] = "newsletter";
    ProductTypeTableNames["Whitepaper"] = "whitepaper";
    ProductTypeTableNames["MarketingCommunication"] = "marketing_communication";
    ProductTypeTableNames["League"] = "league";
    ProductTypeTableNames["Team"] = "team";
    ProductTypeTableNames["Player"] = "player";
    ProductTypeTableNames["Ticker"] = "ticker";
})(ProductTypeTableNames = exports.ProductTypeTableNames || (exports.ProductTypeTableNames = {}));
//# sourceMappingURL=product.item.model.js.map